const initialFiduciaryState = {
  fetching: false,
  fetched: false,
  error: null,
  data: null
};

export const fiduciaryReducer = (state = initialFiduciaryState, action) => {
  switch (action.type) {
    case "FETCH_FIDUCIARY_PENDING": {
      return { ...state, fetched: false, fetching: true };
    }
    case "FETCH_FIDUCIARY_FULFILLED": {
      const { data } = action.payload.data;
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        data: data
      };
    }
    case "FETCH_FIDUCIARY_REJECTED": {
      let error = action.payload;
      if (!error.response) {
        error = {
          title: error,
          code: 500
        };
      } else {
        switch (error.response.status) {
          case 404:
            error = {
              title: error.response.data.title,
              code: 404
            };
            break;
          default:
        }
      }
      return {
        ...state,
        fetching: false,
        data: null,
        error
      };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/fiduciary.js